var ezdia;
(function (ezdia) {
    function queueTaskDetail(label, value) {
        return "<div class=\"form-group form-group-view\">\n      <label class=\"control-label\">" + label + "</label>\n      <div class=\"inputs\">" + value + "</div>\n    </div>";
    }
    function queueTaskDetails(data) {
        var e_1, _a;
        var htmlContent = [];
        try {
            for (var _b = __values(Object.entries(data)), _c = _b.next(); !_c.done; _c = _b.next()) {
                var _d = __read(_c.value, 2), key = _d[0], value = _d[1];
                if (value) {
                    var content = queueTaskDetail(key, value);
                    htmlContent.push(content);
                }
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            }
            finally { if (e_1) throw e_1.error; }
        }
        return "<div class=\"panel-body\">" + htmlContent.join('') + "</div>";
    }
    function queueTaskDetailError(message) {
        return "<div class=\"ez-callout ez-callout-warning\">" + message + "</div>";
    }
    function getActionBtnContent(enabel) {
        var htmlContent = "<i class=\"fa fa-eye\"></i>Enable";
        if (enabel) {
            htmlContent = "<i class=\"fa fa-eye-slash\"></i>Disable";
        }
        return htmlContent;
    }
    function defaultRulesMenu(id, type) {
        var contextRoot = ezdia.config.user.context_root;
        var enabel = type === 'open';
        var htmlContent = "<a href=\"javascript:void(0);\" class=\"btn btn-default btn-circle-icon ez-ellipsis-v-btn\" data-toggle=\"dropdown\" data-options=\"options\"><i class=\"fa fa-circle\"></i><i class=\"fa fa-circle\"></i><i class=\"fa fa-circle\"></i></a>\n      <ul class=\"dropdown-menu\" role=\"menu\" data-chart=\"dropdown\">\n        <li><a href=\"" + contextRoot + "/desk/MyTask.htm?accountName=expert&role=pm&userManagement=true&editQueueId=" + id + "\"><i class=\"fa fa-edit\"></i>Edit</a></li>\n        <li><a data-id=\"" + id + "\" data-enabel=\"" + !enabel + "\" href=\"javascript:void(0)\">\n        " + getActionBtnContent(enabel) + "</a></li>\n      </ul>\n    ";
        return htmlContent;
    }
    function defaultRulesTable(tabelId, data) {
        var rows = [];
        rows = data.map(function (_a) {
            var accountName = _a.accountName, role = _a.role, colValue = _a.colValue, projectType = _a.projectType, orderId = _a.orderId, user = _a.user, name = _a.name, type = _a.type;
            return "<tr>\n          <td>" + (accountName || '') + "</td>\n          <td>" + (role || '') + "</td>\n          <td>" + (colValue || '') + "</td>\n          <td>" + (projectType || '') + "</td> \n          <td>" + (orderId || '') + "</td>\n          <td>" + (user || '') + "</td>    \n          <td class=\"actions-td\">" + defaultRulesMenu(name, type) + "</td>\n        </tr>";
        });
        var htmlContent = "<div class=\"panel panel-project-def-rule\">\n      <div class=\"panel-heading\">\n        <div class=\"title\">Default Rules</div>\n      </div>\n      <div class=\"panel-body\">\n        <table id=\"" + tabelId + "\" class=\"table-project-def-rule\">\n          <thead>\n            <tr>\n              <th>Account Name</th> \n              <th>Role</th> \n              <th>Additional Condition</th>\n              <th>Project Type</th> \n              <th>Order Id</th>\n              <th>Rule</th>\n              <th></th>\n            </tr>            \n          </thead>\n          <tbody>" + rows.join('') + "</tbody>\n        </tabel>\n      </div>\n    ";
        return htmlContent;
    }
    function getDefaultSysMsg(message) {
        return "<div class=\"alert alert-warning\">" + (message || '') + "<div>";
    }
    var templates;
    (function (templates) {
        templates.queueManagement = {
            defaultRulesTable: defaultRulesTable,
            getActionBtnContent: getActionBtnContent,
            queueTaskDetails: queueTaskDetails,
            queueTaskDetailError: queueTaskDetailError,
            getDefaultSysMsg: getDefaultSysMsg
        };
    })(templates = ezdia.templates || (ezdia.templates = {}));
})(ezdia || (ezdia = {}));
